import cn from 'classnames'
import React, { useEffect } from 'react'
import useShowHide, { ShowHideHandlers } from '../../utils/useShowHide.ts'
import styles from './Accordion.module.less'

interface AccordionProps {
    button: (options: ShowHideHandlers) => React.ReactNode
    children: React.ReactNode
    initialOpened?: boolean
}

export const Accordion: React.FC<AccordionProps> = ({ initialOpened, button, children }) => {
    const content = useShowHide(!!initialOpened)
    useEffect(() => {
        if (initialOpened) content.open()
    }, [initialOpened])
    return (
        <div className={cn(styles.root, { [styles.expanded]: content.visible })}>
            <div className={styles.button}>{button(content)}</div>
            <div className={styles.content}>{children}</div>
        </div>
    )
}
